export { default, links, meta } from "/home/node/app/app/root.tsx";